import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Event, NavigationEnd, NavigationStart, NavigationError, NavigationCancel,  } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { Angulartics2GoogleGlobalSiteTag } from "angulartics2/gst";
import { LoadingStatusService } from "@core/service/loading-status.service";
import { PageTitleService } from "@core/service/page-title.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

  constructor(
    protected readonly _router: Router,
    protected readonly _activatedRoute: ActivatedRoute,
    protected readonly _loadingStatus: LoadingStatusService,
    protected readonly _titleService: PageTitleService,
    analytics: Angulartics2GoogleGlobalSiteTag
  ) {
    analytics.startTracking();
  }

  public ngOnInit(): void {
    this._router.events.pipe(
      filter((event: Event) => event instanceof NavigationEnd),
      map(() => this._activatedRoute),
      map((route: ActivatedRoute) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === "primary"),
      mergeMap(route => route.data)
    ).subscribe((eventData) => {
      this._titleService.setTitle(eventData.title);
    });

    // Set the loading status
    this._router.events.pipe(
      filter((event: Event) => {
        return event instanceof NavigationStart
          || event instanceof NavigationEnd
          || event instanceof NavigationCancel
          || event instanceof NavigationError;
      })
    ).subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this._loadingStatus.loading = true;
      } else {
        this._loadingStatus.loading = false;
      }
    });
  }
}
